import React from 'react'
import { MetaMaskProvider } from 'metamask-react'
import { ProvideAuth } from '../auth'
import { ProvideBlockchain } from '../blockchain'
import { CombineProviders } from './CombineProviders'

/**
 * ordering matter, providers will be combined from left to right (outer to inner)
 * this is important because some contexts might be used in other contexts
 * (e.g. we want auth context to be on top since we're using it to check if the user
 * exists in the blockchain context)
 */
const providers = [MetaMaskProvider, ProvideAuth, ProvideBlockchain] as React.FC<React.PropsWithChildren>[]

const AppContextProvider: React.FC<React.PropsWithChildren> = CombineProviders(providers)

export default AppContextProvider
